export const FOCUS_DIM_OPACITY = 0.12
export const ZOOM_HIDE_PATHS_THRESHOLD = 0.15
export const RECENCY_FULL_OPACITY_MINUTES = 30
export const RECENCY_MIN_OPACITY = 0.2

export const TRAIL_WINDOW_OPTIONS = [
    { label: '30m', value: 30 },
    { label: '1h', value: 60 },
    { label: '2h', value: 120 },
    { label: 'All', value: null },
] as const

export type TrailWindowValue = (typeof TRAIL_WINDOW_OPTIONS)[number]['value']

export const USER_COLORS = [
    '#3B82F6',
    '#EF4444',
    '#10B981',
    '#F59E0B',
    '#8B5CF6',
    '#EC4899',
    '#14B8A6',
    '#F97316',
    '#06B6D4',
    '#84CC16',
    '#E11D48',
    '#7C3AED',
    '#D97706',
    '#059669',
]
